import { http } from '@/core/helpers/axiosHelper';
import { Patch } from '@/core/models/patch.interface';
import { Timetable } from '@/core/models/timetable.interface';

export class TimetableService {
   async patchTimetable(contractId: number, timetableId: number, itemsToPatch: Array<Patch>) {
      const response = await http.patch<Timetable>(`/contracts/${contractId}/timetables/${timetableId}`, itemsToPatch);
      return response.data;
   }
}
